// extracted by mini-css-extract-plugin
export var container = "CodeSnippet-module--container--050e5";
export var content = "CodeSnippet-module--content--5e1df";
export var title = "CodeSnippet-module--title--3d575";